import React, { Component } from 'react';
import classNames from 'classnames';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { mergeStyles } from 'wix-rich-content-common';
import MediaItemErrorMsg from './MediaItemErrorMsg.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../Icons/ErrorIcon.js';

var css_248z = ".z6bpq{position:relative}[dir] .z6bpq{background-position:50%;background-repeat:no-repeat}.DcFA6{display:block;height:100%;max-width:100%;visibility:hidden}";
var styles = {"image_container":"z6bpq","image_placeholder":"DcFA6"};
styleInject(css_248z);

class Image extends Component {
  constructor(props) {
    super(props);
    this.styles = mergeStyles({ styles, theme: props.theme });
  }
  render() {
    const { styles: styles2 } = this;
    const { src, resizeMode, className, alt, error, t } = this.props;
    const imageStyle = {
      backgroundImage: `url(${src})`,
      backgroundSize: resizeMode
    };
    return /* @__PURE__ */ React.createElement("div", { className: classNames(styles2.image_container, className), style: imageStyle }, /* @__PURE__ */ React.createElement("img", { src, className: styles2.image_placeholder, alt }), error && /* @__PURE__ */ React.createElement(MediaItemErrorMsg, { error, t }));
  }
}
Image.defaultProps = {
  resizeMode: "contain"
};

export { Image as default };
//# sourceMappingURL=Image.js.map
